import { createCustomSlice } from 'core/utils';

const initialState = {
    error: '',
    loginExternalStatus: '',
    logoutModal: false,
    roleSelector: false,
    socket: null,
    token: null,
    user: {},
    version: null,
    ...JSON.parse(localStorage.getItem('sessionData') ?? '{}')
};

const accountSlice = createCustomSlice({
    initialState,
    name: 'account',
    reducers: {
        accountLogoutModalToggle (state) {
            state.logoutModal = !state.logoutModal;
        },
        accountReset (state) {
            localStorage.clear();
            if (state.socket) {
                state.socket.removeAllListeners();
            }
            state.user = {};
            state.socket = null;
            state.token = null;
        },
        replaceAccountUser (state, { payload }) {
            const data = localStorage.getItem('sessionData') ?? '{}';
            const newUserData = { ...state.user, ...payload };
            state.user = newUserData;
            localStorage.setItem('sessionData', JSON.stringify({ ...JSON.parse(data), user: newUserData }));
        },
        setAccountToken (state, { payload }) {
            const data = localStorage.getItem('sessionData');
            state.token = payload;
            localStorage.setItem('sessionData', JSON.stringify({ ...JSON.parse(data), token: payload }));
        },
        setAccountUser (state, { payload }) {
            const data = localStorage.getItem('sessionData');
            state.user = payload;
            localStorage.setItem('sessionData', JSON.stringify({ ...JSON.parse(data), user: payload }));
        }
    },
    saga: [
        'changeProfile',
        'checkToken',
        'checkVersion',
        'loginAccount',
        'logoutAccount',
        'resetPassword'
    ]
});

export const accountActions = accountSlice.actions;

export default accountSlice.reducer;
